import { useEffect } from "react";
import { Button } from "@cpnw/ui";
import styles from "./NewGetStarted.module.css";
import { StaticRoutes } from "pages/routes";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Link } from "react-router-dom";

const NewGetStarted = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const history = useHistory();

  const handleClick = (partnerType) => {
    if (partnerType === "Healthcare Partner") {
      history.push(StaticRoutes.GetStartedHealthcareForm);
    } else {
      history.push(StaticRoutes.GetStartedAcademicForm);
    }
  };

  return (
    <div className={styles.getStarted}>
      <h1>Welcome to CPNW!</h1>

      <p>
        Welcome to CPNW! We’re excited to support you and your organization’s
        needs. Before completing the registration page, we ask that you first
        establish a Membership/User Agreement to outline our service options and
        determine the best fit for your needs.
      </p>

      <p>
        If you haven’t setup a User Agreement yet, please follow this{" "}
        <a href="/membership-inquiry" className={styles.inquiryLink}>
          Membership Inquiry link
        </a>{" "}
        for more information. If a Membership/User Agreement is established,
        please proceed through the Website Registration Process. We look forward
        to working with you!
      </p>

      <p>
        Are you representing a{" "}
        <Link to={StaticRoutes.GetStartedHealthcareForm}>
          <span className={styles.highlight}>Healthcare Partner</span>
        </Link>{" "}
        or{" "}
        <Link to={StaticRoutes.GetStartedAcademicForm}>
          <span className={styles.highlight}>Academic Partner</span>
        </Link>{" "}
        ?
      </p>

      <div className={styles.buttonRow}>
        <Button
          text="Healthcare Partner"
          onClick={() => handleClick("Healthcare Partner")}
          className={`${styles.roundedBtn} ${styles.slimWideBtn}`}
        />
        <Button
          text="Academic Partner"
          onClick={() => handleClick("Academic Partner")}
          className={`${styles.roundedBtn} ${styles.slimWideBtn}`}
        />
      </div>
    </div>
  );
};

export default NewGetStarted;
